import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';

function ViewClient() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
    const [employeeData, setEmployeeData] = useState('');

    const getEmployee = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/clients/clients/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setEmployeeData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
		getEmployee();
	},[]);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">Client Data</h4>
				  <p class="mb-0 box-subtitle">All Clients Data</p>
				</div>
				<div class="box-body">
					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>Name</th>
								<th>Brand</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Company Phone</th>
								<th>Date</th>
								<th>View</th>
								
							</tr>
						</thead>
						<tbody>
							{employeeData.length > 0 ? employeeData.map((employee, index) =>
							<tr key={index}>
								<td class="text-dark">{employee.name}</td>
								<td>{employee.companyName}</td>
								<td>{employee.companyEmail}</td>
								<td>{employee.phone}</td>
								<td>{employee.companyContact}</td>
								<td>{employee.date}</td>
								<td>
									<a href={`/clients-schedule?id=${employee.id}`} class="form-control" style={{textAlign: 'center'}}>View</a>
								</td>
								
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Client Data</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default ViewClient;